import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../../../form/formUtilities';

export const createInitialForm = runup => fromJS({
  id: normalizeInitialFormValues(runup, ['id']),
  year: normalizeInitialFormValues(runup, ['year']),
  month: normalizeInitialFormValues(runup, ['month']),
  day: normalizeInitialFormValues(runup, ['day']),
  arrDay: normalizeInitialFormValues(runup, ['arrDay']),
  arrHour: normalizeInitialFormValues(runup, ['arrHour']),
  arrMin: normalizeInitialFormValues(runup, ['arrMin']),
  travHours: normalizeInitialFormValues(runup, ['travHours']),
  travMins: normalizeInitialFormValues(runup, ['travMins']),
  period: normalizeInitialFormValues(runup, ['period']),
  firstMotion: normalizeInitialFormValues(runup, ['firstMotion']),
  latitude: normalizeInitialFormValues(runup, ['latitude']),
  longitude: normalizeInitialFormValues(runup, ['longitude']),
  locationName: normalizeInitialFormValues(runup, ['locationName']),
  area: normalizeInitialFormValues(runup, ['area']),
  country: normalizeInitialFormValues(runup, ['country']),
  regionCode: normalizeInitialFormValues(runup, ['regionCode']),
  runupHt: normalizeInitialFormValues(runup, ['runupHt']),
  runupHoriz: normalizeInitialFormValues(runup, ['runupHoriz']),
  typeMeasurementId: normalizeInitialFormValues(runup, ['typeMeasurementId']),
  damageMillionsDollars: normalizeInitialFormValues(runup, ['damageMillionsDollars']),
  damageAmountOrder: normalizeInitialFormValues(runup, ['damageAmountOrder']),
  housesDestroyed: normalizeInitialFormValues(runup, ['housesDestroyed']),
  housesDestroyedAmountOrder: normalizeInitialFormValues(runup, ['housesDestroyedAmountOrder']),
  deaths: normalizeInitialFormValues(runup, ['deaths']),
  deathsAmountOrder: normalizeInitialFormValues(runup, ['deathsAmountOrder']),
  injuries: normalizeInitialFormValues(runup, ['injuries']),
  injuriesAmountOrder: normalizeInitialFormValues(runup, ['injuriesAmountOrder']),
  comments: normalizeInitialFormValues(runup, ['comments']),
  missing: normalizeInitialFormValues(runup, ['missing']),
  missingAmountOrder: normalizeInitialFormValues(runup, ['missingAmountOrder']),
  doubtful: normalizeInitialFormValues(runup, ['doubtful'], 'n'),
  flagLocChk: normalizeInitialFormValues(runup, ['flagLocChk'], false),
  flagRunupChk: normalizeInitialFormValues(runup, ['flagRunupChk'], false),
  flagArrTravTimeChk: normalizeInitialFormValues(runup, ['flagArrTravTimeChk'], false),
  flagEffectsChk: normalizeInitialFormValues(runup, ['flagEffectsChk'], false),
  housesDamaged: normalizeInitialFormValues(runup, ['housesDamaged']),
  housesDamagedAmountOrder: normalizeInitialFormValues(runup, ['housesDamagedAmountOrder']),
  maxWaveArrDay: normalizeInitialFormValues(runup, ['maxWaveArrDay']),
  maxWaveArrHour: normalizeInitialFormValues(runup, ['maxWaveArrHour']),
  maxWaveArrMin: normalizeInitialFormValues(runup, ['maxWaveArrMin']),
  publish: normalizeInitialFormValues(runup, ['publish'], true),
  tsunamiEventId: normalizeInitialFormValues(runup, ['tsunamiEventId']),
  referenceIds: runup && runup.get('referenceIds') ? runup.get('referenceIds').map(v => `${v}`) : [],
  maxTroughHt: normalizeInitialFormValues(runup, ['maxTroughHt']),
  maxTroughDay: normalizeInitialFormValues(runup, ['maxTroughDay']),
  maxTroughHour: normalizeInitialFormValues(runup, ['maxTroughHour']),
  maxTroughMin: normalizeInitialFormValues(runup, ['maxTroughMin']),
});

export const runupEditModel = fromJS({
  name: 'runupEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  year: fieldToNumber(form.get('year')),
  month: fieldToNumber(form.get('month')),
  day: fieldToNumber(form.get('day')),
  arrDay: fieldToNumber(form.get('arrDay')),
  arrHour: fieldToNumber(form.get('arrHour')),
  arrMin: fieldToNumber(form.get('arrMin')),
  travHours: fieldToNumber(form.get('travHours')),
  travMins: fieldToNumber(form.get('travMins')),
  period: fieldToNumber(form.get('period')),
  firstMotion: fieldTrimmed(form.get('firstMotion')),
  latitude: fieldToNumber(form.get('latitude')),
  longitude: fieldToNumber(form.get('longitude')),
  locationName: fieldTrimmed(form.get('locationName')),
  area: fieldTrimmed(form.get('area')),
  country: fieldTrimmed(form.get('country')),
  regionCode: fieldToNumber(form.get('regionCode')),
  runupHt: fieldToNumber(form.get('runupHt')),
  runupHoriz: fieldToNumber(form.get('runupHoriz')),
  typeMeasurementId: fieldToNumber(form.get('typeMeasurementId')),
  damageMillionsDollars: fieldToNumber(form.get('damageMillionsDollars')),
  damageAmountOrder: fieldToNumber(form.get('damageAmountOrder')),
  housesDestroyed: fieldToNumber(form.get('housesDestroyed')),
  housesDestroyedAmountOrder: fieldToNumber(form.get('housesDestroyedAmountOrder')),
  deaths: fieldToNumber(form.get('deaths')),
  deathsAmountOrder: fieldToNumber(form.get('deathsAmountOrder')),
  injuries: fieldToNumber(form.get('injuries')),
  injuriesAmountOrder: fieldToNumber(form.get('injuriesAmountOrder')),
  comments: fieldTrimmed(form.get('comments')),
  missing: fieldToNumber(form.get('missing')),
  missingAmountOrder: fieldToNumber(form.get('missingAmountOrder')),
  doubtful: fieldTrimmed(form.get('doubtful')),
  flagLocChk: Boolean(form.get('flagLocChk')),
  flagRunupChk: Boolean(form.get('flagRunupChk')),
  flagArrTravTimeChk: Boolean(form.get('flagArrTravTimeChk')),
  flagEffectsChk: Boolean(form.get('flagEffectsChk')),
  housesDamaged: fieldToNumber(form.get('housesDamaged')),
  housesDamagedAmountOrder: fieldToNumber(form.get('housesDamagedAmountOrder')),
  maxWaveArrDay: fieldToNumber(form.get('maxWaveArrDay')),
  maxWaveArrHour: fieldToNumber(form.get('maxWaveArrHour')),
  maxWaveArrMin: fieldToNumber(form.get('maxWaveArrMin')),
  publish: Boolean(form.get('publish')),
  tsunamiEventId: fieldToNumber(form.get('tsunamiEventId')),
  referenceIds: fromJS(form.get('referenceIds')).map(fieldToNumber).filter(value => value != null),
  maxTroughHt: fieldToNumber(form.get('maxTroughHt')),
  maxTroughDay: fieldToNumber(form.get('maxTroughDay')),
  maxTroughHour: fieldToNumber(form.get('maxTroughHour')),
  maxTroughMin: fieldToNumber(form.get('maxTroughMin')),
});
